import React from 'react';
import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BoldSmallBodyText, Header5Text, SmallBodyText, SpacerRow, Tooltip } from 'ui-toolkit';

export interface IExpectedBorrowerMoneyLabelProps {}

export const ExpectedBorrowerMoneyLabel: React.FC<IExpectedBorrowerMoneyLabelProps> = () => {
  return (
    <Tooltip
      placement={'bottom'}
      tooltipContent={
        <>
          <BoldSmallBodyText>What is this?</BoldSmallBodyText>
          <SmallBodyText>
            This represents value of the funds that Spruce expects to fulfill Borrower Cash to Close.
          </SmallBodyText>
          <SpacerRow />
          <BoldSmallBodyText>How is it calculated?</BoldSmallBodyText>
          <SmallBodyText>
            Loan amount
            <br />
            - Borrower closing costs to be paid at closing
            <br />
            - Payoffs
            <br />= Expected Borrower Money
          </SmallBodyText>
        </>
      }
    >
      <div className={'flex flex-row gap-1 items-center'}>
        <Header5Text>Borrower</Header5Text>
        <FontAwesomeIcon icon={faQuestionCircle} />
      </div>
    </Tooltip>
  );
};
